import { inject, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { filter, switchMap } from "rxjs/operators";

import { AWSHttpClient } from "@intocare/aws";
import { GlobalInfo } from "@intocare/interfaces";

import * as reducers from "../../core/reducers";
import { SetGlobalInfo } from "../actions/global-info";

@Injectable()
export class GlobalInfoModel {
	private store = inject<Store<reducers.State>>(Store);
	private http = inject(AWSHttpClient);

	globalInfo$ = this.store.select(reducers.getGlobalInfo);

	loadGlobalInfo() {
		this.globalInfo$
			.pipe(
				filter((info) => !info),
				switchMap(() => this.http.get<GlobalInfo>("globals")),
			)
			.subscribe((data) => {
				this.store.dispatch(new SetGlobalInfo(data));
			});
	}
}
